export default class DtoCentral {
    constructor(obj) {
        this.id = obj.id
        this.reference = obj.reference
        this.comment = obj.comment
        this.centralType = obj.centralType
        this.materielType = obj.centralType
        this.purchaseDate = obj.purchaseDate
        this.warrantyTime = obj.warrantyTime
        this.manufactureDate = obj.manufactureDate
        this.withdrawalDate = obj.withdrawalDate
        this.providerId = obj.providerId
        this.serialNumber = obj.serialNumber
        this.thresholdOverrun = obj.thresholdOverrun
        this.manufacturerId = obj.manufacturerId
        this.updateDate = obj.updateDate
        this.replacementDate = obj.replacementDate
        this.callFrequency = obj.callFrequency
        this.callHour = obj.callHour
        this.updateLogin = obj.updateLogin
        this.referentLogin = obj.referentLogin
        this.pileNumber = obj.pileNumber
        this.powerSupplyType = obj.powerSupplyType
        this.transmissionVolume = obj.transmissionVolume
        this.jobExecutionId = obj.jobExecutionId
    }
}
